import React, { useState } from "react";
import {
  Box,
  Flex,
  Text,
  Spacer,
} from "@chakra-ui/react";
import { AiOutlineRight } from "react-icons/ai";
import { Switch, Route, useHistory } from "react-router-dom";

import Sidebar from "../sections/Sidebar/Sidebar";
// import RingLoader from "react-spinners/RingLoader";

import BreadCrumbs from "../common/BreadCrumbs";
import MerchantViewEdit from "./MerchantViewEdit";
import CaseTriggerViewEdit from "./CaseTriggerViewEdit";
import RuleManagement from "./RuleManagement";
import CountryManagement from "./CountryManagement";
import Loader from '../common/Loader';
import Header from  '../sections/Header';

import "./preference.css";

// A clickable row in the settings list that navigates to a full-page editor.
function SettingsRow({ label, onClick }) {
  return (
    <Box
      w="100%"
      borderRadius="lg"
      backgroundColor="#f7f7fa"
      mb={2}
      p={2}
      h={12}
      cursor="pointer"
      onClick={onClick}
      _hover={{ backgroundColor: "#e9eef5" }}
    >
      <Flex pt={1} alignItems="center">
        <Text fontSize="14px">{label}</Text>
        <Spacer />
        <Box as={AiOutlineRight} color="gray.400" />
      </Flex>
    </Box>
  );
}

function Preference() {
  const [isLoading, setisLoading] = useState(false);
  const history = useHistory();
  const back = () => history.push("/preference");

  return (
    <Box>
      <Flex>
        <Box>
          <Sidebar />
        </Box>
        <Box w="100%">
          <Loader isLoading={isLoading} />
          <Header></Header>
          <Box pl="2" pb="2">
            <BreadCrumbs />
          </Box>
          <Flex
            borderRadius="lg"
            borderWidth="1px"
            p={3}
            ml={3}
            mr={3}
            flexDirection="column"
            overflowY="auto"
            h="87vh"
          >
            <Switch>
              <Route
                path="/preference/merchant-view"
                render={() => <MerchantViewEdit setisLoading={setisLoading} onBack={back} />}
              />
              <Route
                path="/preference/case-view"
                render={() => <CaseTriggerViewEdit setisLoading={setisLoading} onBack={back} />}
              />
              {/* Deep-linkable: /preference/rule-management/<country> (refresh-safe) */}
              <Route
                path="/preference/rule-management/:country?"
                render={(props) => (
                  <RuleManagement
                    setisLoading={setisLoading}
                    country={props.match.params.country || "default"}
                    onBack={back}
                  />
                )}
              />
              <Route
                path="/preference/country-management"
                render={() => <CountryManagement setisLoading={setisLoading} onBack={back} />}
              />
              <Route
                path="/preference"
                render={() => (
                  <>
                    <SettingsRow label="Merchant view column preference" onClick={() => history.push("/preference/merchant-view")} />
                    <SettingsRow label="Case view column preference" onClick={() => history.push("/preference/case-view")} />
                    <SettingsRow label="Rule management" onClick={() => history.push("/preference/rule-management/default")} />
                    <SettingsRow label="Country management" onClick={() => history.push("/preference/country-management")} />
                  </>
                )}
              />
            </Switch>
          </Flex>
        </Box>
      </Flex>
    </Box>
  );
}

export default Preference;
